import { bindActionCreators } from 'redux'
import * as StoreActions from 'x/modules/store/StoreState'
import { connect } from 'react-redux'
import { getState, getDispatch } from 'x/modules/order/BaseOrderViewConnect'
import AssistantGroupListView from './AssistantGroupListView'

export default connect(
  (state) => ({
    ...getState(state),
  }),
  (dispatch) => ({
    ...getDispatch(dispatch),
    getPermissionList: bindActionCreators(StoreActions.getPermissionList, dispatch),
  })
)(AssistantGroupListView)
